<template>
  <div>
    <div class="row">
      <div class="form-group col-md-6">
        <img v-bind:src="this.imageUrl" width="500" height="500" />
      </div>
    </div>
    <div class="row" v-if="this.existingFiles.length">
          <div class="form-group col-md-6">
          <button type="button" class="btn btn-danger" v-if="compMode !== CRUDMODE.READ" v-on:click.stop="deleteFile()"><span class="fa fa-lg fa-trash"></span>&nbsp; Supprimer l'image</button>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="nameInput">{{ $t('file.type.' + this.fileType ) }}</label>
        <input
          name="photo"
          type="file"
          class="form-control"
          ref="photo"
          @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
          id="photo"
          accept="image/*"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Enum from '../enum'
import ServiceFactory from '../service-clients/serviceClientFactory'
import {FileServiceClient, FilesServiceClient, FileDto, BlobFileInfosDto, PersistFileDto} from '../service-clients/service-clients'

// Maybe rename this, not only use for photo anymore
export default {
  name: 'PhotoUploader',
  props: {
    entite: {
      type: String,
      required: true,
    },
    compMode: {
      default: Enum.Mode.CREATE,
    },
    fileType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      CRUDMODE: Enum.Mode,
      uploadFieldName: 'photo',
      files: [],
      existingFiles: [],
      imageUrl: '',
    }
  },
  computed: {},
  methods: {
    fetchFiles(param) {
      let service = ServiceFactory.create(FileServiceClient)
      service
        .getAll(param.id, param.entite, '', param.fileType, '', 0, 10000)
        .then(res => {
          this.existingFiles = this.existingFiles.concat(res.items)
          this.getImageUrl()
        })
        .catch(err => {
          console.log(err)
        })
    },
    uploadFile(formData) {
      let baseUrl = process.env.API_URL
      let accessToken = Vue.cookie.get('accessToken')
      let self = this
      return new Promise(function(resolve, reject) {
        let xhr = new XMLHttpRequest()
        xhr.open('POST', baseUrl + '/temp-files')
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken)
        xhr.onreadystatechange = e => {
          if (xhr.readyState === xhr.DONE) {
            if (xhr.status === 200) {
              let data = JSON.parse(xhr.responseText)
              let uploaded = _.map(data.result, map => {
                let dto = new BlobFileInfosDto()
                dto.init(map)
                dto.changed = true

                let fileDto = new FileDto()
                fileDto.init({
                  infos: dto,
                  name: dto.fileName,
                  entite: self.entite,
                  fileType: self.fileType,
                })

                return fileDto
              })

              self.files = self.files.concat(uploaded)
              resolve({
                status: xhr.status,
              })
            } else {
              reject({
                status: xhr.status,
                statusText: xhr.statusText,
              })
            }
          }
        }
        xhr.send(formData)
      })
    },
    deleteFile() {
      //console.log(this.existingFiles)
      let service = ServiceFactory.create(FileServiceClient)
      let dto = new PersistFileDto()
      var toDelete = []

      toDelete = this.existingFiles

      dto.init({
        persistedFiles: [],
        deletedFiles: toDelete,
      })

      this.existingFiles = []
      this.imageUrl = '/static/assets/person_placeholder.png'

      return service.persistPhoto(dto)
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name)
      })

      // save it
      this.uploadFile(formData)
    },
    persistPhoto(idEntite) {
      let service = ServiceFactory.create(FileServiceClient)
      let dto = new PersistFileDto()
      var toDelete = []

      if (this.files.length !== 0) {
        toDelete = this.existingFiles
      }
      dto.init({
        idEntite: idEntite,
        persistedFiles: this.files,
        deletedFiles: toDelete,
      })
      return service.persistPhoto(dto)
    },
    getImageUrl() {
      let self = this
      let service = ServiceFactory.create(FilesServiceClient)
      let file = this.existingFiles[0]

      let fileUrl = ''
      if (file) {
        service
          .download(
            file.infos.changed,
            file.infos.fileName,
            file.infos.relativePath,
            file.infos.host,
            file.infos.absoluteUri,
            file.infos.contentType,
            file.infos.contentLength
          )
          .then(res => {
            self.imageUrl = res
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        self.imageUrl = '/static/assets/person_placeholder.png'
      }
    },
  },
  mounted() {
    if (this.compMode != null && this.compMode != Enum.Mode.CREATE && this.compMode != Enum.Mode.COPY) {
      this.fetchFiles({
        entite: this.entite,
        id: this.$route.params.id,
        fileType: this.fileType,
      })
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/shared/components/PhotoUploader.vue